import React from "react"
import { Link } from "gatsby"
import { graphql, useStaticQuery } from "gatsby"
import SocialLinks from "../../constants/socialLinks"

import { FiArrowDownCircle } from "react-icons/fi"

import { motion } from "framer-motion"
import {
  Header,
  Content,
  Line,
  ImageStyled,
  Title,
  SubTitle,
  ImageWrapper,
  Info,
  DownArrow,
} from "./Hero.styled"
const variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      staggerChildren: 0.4,
    },
  },
}

const item = {
  hidden: { opacity: 0, y: 500 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: "easeInOut",
    },
  },
}
const query = graphql`
  {
    file(relativePath: { eq: "wondeshi_wbg.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`

const Hero = () => {
  const {
    file: {
      childImageSharp: { fluid },
    },
  } = useStaticQuery(query)

  return (
    <Header>
      <Content className="section-center" id="hero">
        <Info>
          <motion.div initial="hidden" animate="visible" variants={variants}>
            <Line variants={item}></Line>
            <Title variants={item}>i'm Wondwosen</Title>
            <SubTitle variants={item}> Fullstack Developer</SubTitle>
            <motion.div variants={item}>
              <Link to="/contact" className="btn">
                contact me
              </Link>
            </motion.div>
            <motion.div variants={item}>
              <SocialLinks />
            </motion.div>
          </motion.div>
        </Info>
        <a href="#service">
          <DownArrow>
            <FiArrowDownCircle />
          </DownArrow>
        </a>
      </Content>
    </Header>
  )
}

export default Hero

// Photo
{
  /* <ImageWrapper
          initial={{ x: 2000, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 2 }}
        >
          <ImageStyled fluid={fluid} />
        </ImageWrapper> */
}
